import { NoSsr } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { calculateTimeLeft } from 'utils';

// thuannc
// TODO:
// MUST FIX

function CountdownTimerDetail({ prefix, dealEndDay, translateProductDetail, ...otherProps }) {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(dealEndDay));

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft(dealEndDay));
    }, 1000);
    return () => clearTimeout(timer);
  });

  const timerComponents = [];
  Object.keys(timeLeft).forEach((interval) => {
    if (!timeLeft[interval]) {
      return;
    }

    timerComponents.push(
      <span key={`timer-${Math.random()}`}>
        {timeLeft[interval]}
        {/* 13Oct2023
        new format of count down: days : hours : minutes : seconds */}
        {interval === 'days' ? ` : ` : null}
        {/* {interval === 'days' ? `${translateProductDetail('days')}, ` : null} */}
      </span>,
    );
  });
  return (
    <NoSsr>
      <div {...otherProps}>
        {timerComponents.length ? (
          <>
            <span>{timerComponents}</span>
          </>
        ) : (
          <span>{translateProductDetail('promotion_ended')}</span>
        )}
      </div>
    </NoSsr>
  );
}

export default CountdownTimerDetail;
